<template>
    <div class="market">
      <div class="banner-top">
        <div class="banner-box"></div>
        <div class="banner-desc">全天候市场重要信息跟踪，重大要闻点评，重点机会解读</div>
      </div>
      <div class="market-box">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, i) in menuList" :key="i">
            <el-tooltip class="item" effect="light" :content="item.desc" placement="bottom" popper-class="third-tooltip">
            <div class="grid-content bg-purple cursorPointer" @click="token && selectMenu(i)">
              <div :class="currentIndex === i ? 'active' : ''"><img class="small-img" :src="currentIndex === i ? item.imgUrl : item.imgUrls" alt="">{{item.txt}}</div>
            </div>
            </el-tooltip>
          </el-col>
        </el-row>

        <div class="list" v-show="currentIndex === ''">
          <div class="list-box" v-for="(item,i) in itemList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=market'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getMore">点击加载更多...</div>
            </div>
          </div>
        </div>

        <div class="list" v-show="currentIndex === 0">

          <div class="time-list">
            <div class="block">
              <el-timeline>
                <div v-for="(item, i) in itemHeadlinesList" :key="i">
                  <div class="time">
                    <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{item.list[0].hour}}</span>
                  </div>
                  <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">
                    <div class="title-name">
                      <div class="time-title">{{obj.title}}</div>
                      <div class="model">{{obj.name}}</div>
                    </div>
                    <div class="time-content" v-html="obj.content"></div>
                    <div class="vip" v-if="obj.status === 0">解锁全文</div>
                  </el-timeline-item>
                </div>
              </el-timeline>
            </div>
            <div class="more">
              <div class="cursorPointer">
                <div @click="getHeadlinesMore()">点击加载更多...</div>
              </div>
            </div>
          </div>



<!--        <div class="article-list" v-show="currentIndex === 0">-->
<!--          <div class="zx-list">-->
<!--              <el-tabs v-model="activeName" type="card" @tab-click="handleClick">-->
<!--                <el-tab-pane label="最新" name="first">-->
<!--                  <div class="time-list">-->
<!--                    <div class="block">-->
<!--                      <el-timeline>-->
<!--                        <div v-for="(item, i) in itemTimeList" :key="i">-->
<!--                          <div class="time">-->
<!--                            <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{item.list[0].hour}}</span>-->
<!--                          </div>-->
<!--                        <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">-->
<!--                          <div class="title-name">-->
<!--                            <div class="time-title">{{obj.title}}</div>-->
<!--                            <div class="model">{{obj.name}}</div>-->
<!--                          </div>-->
<!--                            <div class="time-content" v-html="obj.content"></div>-->
<!--                          <div class="vip" v-if="obj.status === 0">解锁全文</div>-->
<!--                        </el-timeline-item>-->
<!--                        </div>-->
<!--                      </el-timeline>-->
<!--                    </div>-->
<!--                    <div class="more">-->
<!--                      <div class="cursorPointer">-->
<!--                        <div @click="getTimeListMore()">点击加载更多...</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </el-tab-pane>-->
<!--                <el-tab-pane label="精选头条" name="second">-->
<!--                  <div class="time-list">-->
<!--                    <div class="block">-->
<!--                      <el-timeline>-->
<!--                        <div v-for="(item, i) in itemHeadlinesList" :key="i">-->
<!--                          <div class="time">-->
<!--                            <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{item.list[0].hour}}</span>-->
<!--                          </div>-->
<!--                          <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">-->
<!--                            <div class="title-name">-->
<!--                              <div class="time-title">{{obj.title}}</div>-->
<!--                              <div class="model">{{obj.name}}</div>-->
<!--                            </div>-->
<!--                            <div class="time-content" v-html="obj.content"></div>-->
<!--                            <div class="vip" v-if="obj.status === 0">解锁全文</div>-->
<!--                          </el-timeline-item>-->
<!--                        </div>-->
<!--                      </el-timeline>-->
<!--                    </div>-->
<!--                    <div class="more">-->
<!--                      <div class="cursorPointer">-->
<!--                        <div @click="getHeadlinesMore()">点击加载更多...</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </el-tab-pane>-->
<!--                <el-tab-pane label="市场热点" name="third">-->
<!--                  <div class="time-list">-->
<!--                    <div class="block">-->
<!--                      <el-timeline>-->
<!--                        <div v-for="(item, i) in itemHotList" :key="i">-->
<!--                          <div class="time">-->
<!--                            <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{item.list[0].hour}}</span>-->
<!--                          </div>-->
<!--                          <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">-->
<!--                            <div class="title-name">-->
<!--                              <div class="time-title">{{obj.title}}</div>-->
<!--                              <div class="model">{{obj.name}}</div>-->
<!--                            </div>-->
<!--                            <div class="time-content" v-html="obj.content"></div>-->
<!--                            <div class="vip" v-if="obj.status === 0">解锁全文</div>-->
<!--                          </el-timeline-item>-->
<!--                        </div>-->
<!--                      </el-timeline>-->
<!--                    </div>-->
<!--                    <div class="more">-->
<!--                      <div class="cursorPointer">-->
<!--                        <div @click="getHotMore()">点击加载更多...</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </el-tab-pane>-->
<!--                <el-tab-pane label="盘中直击" name="fourth">-->
<!--                  <div class="time-list">-->
<!--                    <div class="block">-->
<!--                      <el-timeline>-->
<!--                        <div v-for="(item, i) in itemPkList" :key="i">-->
<!--                          <div class="time">-->
<!--                            <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{item.list[0].hour}}</span>-->
<!--                          </div>-->
<!--                          <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">-->
<!--                            <div class="title-name">-->
<!--                              <div class="time-title">{{obj.title}}</div>-->
<!--                              <div class="model">{{obj.name}}</div>-->
<!--                            </div>-->
<!--                            <div class="time-content" v-html="obj.content"></div>-->
<!--                            <div class="vip" v-if="obj.status === 0">解锁全文</div>-->
<!--                          </el-timeline-item>-->
<!--                        </div>-->
<!--                      </el-timeline>-->
<!--                    </div>-->
<!--                    <div class="more">-->
<!--                      <div class="cursorPointer">-->
<!--                        <div @click="getPkMore()">点击加载更多...</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </el-tab-pane>-->
<!--                <el-tab-pane label="要闻点评" name="five">-->
<!--                  <div class="time-list">-->
<!--                    <div class="block">-->
<!--                      <el-timeline>-->
<!--                        <div v-for="(item, i) in itemCommentsList" :key="i">-->
<!--                          <div class="time">-->
<!--                            <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
<!--                            <span>{{item.list[0].hour}}</span>-->
<!--                          </div>-->
<!--                          <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">-->
<!--                            <div class="title-name">-->
<!--                              <div class="time-title">{{obj.title}}</div>-->
<!--                              <div class="model">{{obj.name}}</div>-->
<!--                            </div>-->
<!--                            <div class="time-content" v-html="obj.content"></div>-->
<!--                            <div class="vip" v-if="obj.status === 0">解锁全文</div>-->
<!--                          </el-timeline-item>-->
<!--                        </div>-->
<!--                      </el-timeline>-->
<!--                    </div>-->
<!--                    <div class="more">-->
<!--                      <div class="cursorPointer">-->
<!--                        <div @click="getCommentsMore()">点击加载更多...</div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </el-tab-pane>-->
<!--              </el-tabs>-->
<!--          </div>-->
        </div>

        <div class="list" v-show="currentIndex === 1">
<!--          <div class="list-box" v-for="(item,i) in itemAgList" :key="i">-->
<!--            <div class="img-box">-->
<!--              <img class="thumb-img" :src="item.img" alt="">-->
<!--            </div>-->
<!--            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=market'">-->
<!--              <div class="article_title">-->
<!--                <div class="title">{{ item.title }}</div>-->
<!--                <div class="list-content">{{ item.desc }}</div>-->
<!--                <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>-->
<!--              </div>-->
<!--            </a>-->
<!--          </div>-->
<!--          <div class="more">-->
<!--            <div class="cursorPointer">-->
<!--              <div @click="getAgMore">点击加载更多...</div>-->
<!--            </div>-->
<!--          </div>-->

          <div class="time-list">
            <div class="block">
              <el-timeline>
                <div v-for="(item, i) in itemHotList" :key="i">
                  <div class="time">
                    <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{item.list[0].hour}}</span>
                  </div>
                  <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">
                    <div class="title-name">
                      <div class="time-title">{{obj.title}}</div>
                      <div class="model">{{obj.name}}</div>
                    </div>
                    <div class="time-content" v-html="obj.content"></div>
                    <div class="vip" v-if="obj.status === 0">解锁全文</div>
                  </el-timeline-item>
                </div>
              </el-timeline>
            </div>
            <div class="more">
              <div class="cursorPointer">
                <div @click="getHotMore()">点击加载更多...</div>
              </div>
            </div>
          </div>



        </div>

        <div class="list" v-show="currentIndex === 2">
<!--          <div class="list-box" v-for="(item,i) in itemRzRqList" :key="i">-->
<!--            <div class="img-box">-->
<!--              <img class="thumb-img" :src="item.img" alt="">-->
<!--            </div>-->
<!--            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=market'">-->
<!--              <div class="article_title">-->
<!--                <div class="title">{{ item.title }}</div>-->
<!--                <div class="list-content">{{ item.desc }}</div>-->
<!--                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>-->
<!--              </div>-->
<!--            </a>-->
<!--          </div>-->
<!--          <div class="more">-->
<!--            <div class="cursorPointer">-->
<!--              <div @click="getRzRqMore">点击加载更多...</div>-->
<!--            </div>-->
<!--          </div>-->

          <div class="time-list">
            <div class="block">
              <el-timeline>
                <div v-for="(item, i) in itemPkList" :key="i">
                  <div class="time">
                    <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{item.list[0].hour}}</span>
                  </div>
                  <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">
                    <div class="title-name">
                      <div class="time-title">{{obj.title}}</div>
                      <div class="model">{{obj.name}}</div>
                    </div>
                    <div class="time-content" v-html="obj.content"></div>
                    <div class="vip" v-if="obj.status === 0">解锁全文</div>
                  </el-timeline-item>
                </div>
              </el-timeline>
            </div>
            <div class="more">
              <div class="cursorPointer">
                <div @click="getPkMore()">点击加载更多...</div>
              </div>
            </div>
          </div>


        </div>


        <div class="list" v-show="currentIndex === 3">
          <!--          <div class="list-box" v-for="(item,i) in itemRzRqList" :key="i">-->
          <!--            <div class="img-box">-->
          <!--              <img class="thumb-img" :src="item.img" alt="">-->
          <!--            </div>-->
          <!--            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=market'">-->
          <!--              <div class="article_title">-->
          <!--                <div class="title">{{ item.title }}</div>-->
          <!--                <div class="list-content">{{ item.desc }}</div>-->
          <!--                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>-->
          <!--              </div>-->
          <!--            </a>-->
          <!--          </div>-->
          <!--          <div class="more">-->
          <!--            <div class="cursorPointer">-->
          <!--              <div @click="getRzRqMore">点击加载更多...</div>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="time-list">
            <div class="block">
              <el-timeline>
                <div v-for="(item, i) in itemCommentsList" :key="i">
                  <div class="time">
                    <span>{{item.date}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{weekArr[new Date(item.date).getDay()]}}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span>{{item.list[0].hour}}</span>
                  </div>
                  <el-timeline-item :timestamp="obj.hour" placement="top" v-for="(obj, j) in item.list" :key="j">
                    <div class="title-name">
                      <div class="time-title">{{obj.title}}</div>
                      <div class="model">{{obj.name}}</div>
                    </div>
                    <div class="time-content" v-html="obj.content"></div>
                    <div class="vip" v-if="obj.status === 0">解锁全文</div>
                  </el-timeline-item>
                </div>
              </el-timeline>
            </div>
            <div class="more">
              <div class="cursorPointer">
                <div @click="getCommentsMore()">点击加载更多...</div>
              </div>
            </div>
          </div>


        </div>

      </div>
      <div class="back-top" @click="backTop" v-show="btnFlag">
        <img src="../assets/images/return_top.png" alt="" srcset="">
      </div>
    </div>
</template>

<script>
import { Market, TimeList, Ag, RzRq, HotList, HeadlinesList,Pk,Comments } from "@/api/news";
export default {
  name: "Market",
  data() {
    return {
      currentTab:'first',
      activeName: 'first',
      itemList: [],
      token: window.localStorage.getItem('token'),
      weekArr : ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],
      dateStatus: [],
      itemTimeList: [],
      itemAgList: [],
      itemRzRqList: [],
      itemHotList: [],
      itemHeadlinesList: [],
      itemPkList: [],
      itemCommentsList: [],
      date:'',
      page: 1,
      zxPage:1,
      ttPage:1,
      rdPage:1,
      pkPage:1,
      plPage:1,
      agPage:1,
      rzPage:1,
      btnFlag: false,
      currentIndex:'',
      weeks: '',
      menuList:[
        {
          imgUrl: require('../assets/images/icon_7x24-2.png'),
          imgUrls: require('../assets/images/icon_7x24-1.png'),
          txt: '精选头条',
          desc: '专业原创点评，有速度，更有深度！（更新频率：交易日实时更新）'
        },
        {
          imgUrl: require('../assets/images/icon_每日A股2.png'),
          imgUrls: require('../assets/images/icon_每日A股1.png'),
          txt: '市场热点',
          desc: '专业原创点评，有速度，更有深度！（更新频率：交易日实时更新）'
        },
        {
          imgUrl: require('../assets/images/icon_融资融券2.png'),
          imgUrls: require('../assets/images/icon_融资融券1.png'),
          txt: '盘中直击',
          desc: '专业原创点评，有速度，更有深度！（更新频率：交易日实时更新）'
        },
        {
          imgUrl: require('../assets/images/icon_融资融券2.png'),
          imgUrls: require('../assets/images/icon_融资融券1.png'),
          txt: '要闻点评',
          desc: '专业原创点评，有速度，更有深度！（更新频率：交易日实时更新）'
        },
      ],
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getAllList()
    // this.getTimeList()
    this.getHotList()
    this.getPkList()
    this.getHeadlinesList()
    this.getCommentsList()
    // this.getAgList()
    // this.getRzRqList()
  },
  mounted() {
    this.market()
    this.toJump()
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    toJump(){
      if(this.$route.query.activeName!=null){
        this.activeName = this.$route.query.activeName;
        this.currentTab = this.$route.query.currentTab;
        const currentMk = this.currentTab;
        // console.log(currentMk);
        // if(currentMk ==='first' || currentMk ==='second' || currentMk === 'third' || currentMk === 'fourth'  || currentMk === 'five'){
        if(currentMk ==='second'){
          this.currentIndex = 0
        }else if(currentMk === 'third'){
          this.currentIndex = 1
        }else if(currentMk === 'fourth'){
          this.currentIndex = 2
        }else if(currentMk === 'five'){
          this.currentIndex = 3
        }
      }
    },
    market(){
      let tabIndex = this.$route.query.currentTab
      if (tabIndex  == 'first') {
        this.itemTimeList = []
        this.getTimeList()
      }else if(tabIndex  == 'second'){
        this.itemHeadlinesList = []
        this.getHeadlinesList()
      }
      else if(tabIndex  == 'third'){
        this.itemHotList = []
        this.getHotList()
      }
      else if(tabIndex  == 'fourth'){
        this.itemPkList = []
        this.getPkList()
      }else if(tabIndex  == 'five') {
        this.itemCommentsList = []
        this.getCommentsList()
      }else if(tabIndex  == 'six') {
        this.itemCommentsList = []
        this.getAgList()
      }else if(tabIndex  == 'seven') {
        this.itemRzRqList = []
        this.getRzRqList()
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      if (tab.name == 'first') {
        this.itemTimeList = []
        this.getTimeList()
      }else if(tab.name == 'second'){
        this.itemHeadlinesList = []
        this.getHeadlinesList()
      }else if(tab.name == 'third'){
        this.itemHotList = []
        this.getHotList()
      }else if(tab.name == 'fourth'){
        this.itemPkList = []
        this.getPkList()
      }else if(tab.name == 'five'){
        this.itemCommentsList = []
        this.getCommentsList()
      }
    },
    selectMenu(index) {
      console.log(index);
      if(index === 1){
        this.itemAgList =  []
        this.getAgList()
      }else if(index ===2){
        this.itemRzRqList = []
        this.getRzRqList()
      }else if(index ===0){
        this.itemTimeList = []
        this.getTimeList()
        // this.$router.push({
        //   query: {
        //     activeName: 'first',
        //     currentTab: 'first',
        //   }
        // })
      }
      this.currentIndex = index
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    getTimeList() {
      TimeList({id: 'yyyg3ws3ay', page: this.zxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTimeList = this.itemTimeList.concat(response.data.data)
        }
      });
    },
    getHeadlinesList() {
      HeadlinesList({id: 'ldscuzf9h9', page: this.ttPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemHeadlinesList = this.itemHeadlinesList.concat(response.data.data)
        }
      });
    },
    getHotList() {
      HotList({id: 'pf4c9djj1q', page: this.rdPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemHotList = this.itemHotList.concat(response.data.data)
        }
      });
    },
    getPkList() {
      Pk({id: '2ru6uhsbhx', page: this.pkPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemPkList = this.itemPkList.concat(response.data.data)
        }
      });
    },
    getCommentsList() {
      Comments({id: 'denzzx0mkb', page: this.plPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemCommentsList = this.itemCommentsList.concat(response.data.data)
        }
      });
    },
    getAllList() {
      Market({id: '1lblrplq7pf', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemList = this.itemList.concat(response.data.data)
        }
      });
    },
    getAgList() {
      Ag({id: '11fkoitz5iv', page: this.agPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemAgList = this.itemAgList.concat(response.data.data)
        }
      });
    },
    getRzRqList() {
      RzRq({id: '18f8y0qbqy7', page: this.rzPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemRzRqList = this.itemRzRqList.concat(response.data.data)
        }
      });
    },
    getMore() {
      this.page++;
      this.getAllList()
    },
    getTimeListMore() {
      this.zxPage++;
      this.getTimeList()
    },
    getHeadlinesMore() {
      this.ttPage++;
      this.getHeadlinesList()
    },
    getHotMore() {
      this.rdPage++;
      this.getHotList()
    },
    getPkMore() {
      this.pkPage++;
      this.getPkList()
    },
    getCommentsMore() {
      this.plPage++;
      this.getCommentsList()
    },
    getAgMore() {
      this.agPage++;
      this.getAgList()
    },
    getRzRqMore() {
      this.rzPage++;
      this.getRzRqList()
    },
  }
}
</script>

<style scoped>
.market {
  background-color: #F5F7FA;
}
.market-box {
  width: 1200px;
  margin: -30px auto 0;
}
.active{
  color: #ffe400;
}
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  height: 60px;
  color: white;
  background-image: linear-gradient(#0c255c, #040f27);
  line-height: 60px;
  font-size: 16px;
  padding-left: 50px;
}

.cursorPointer {
  cursor: pointer;
}

.small-img {
  height: 30px;
  padding-right: 20px;
  vertical-align: middle;
}

.time-list{
  background-color: #FFFFFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  padding: 20px 30px;
  margin-bottom: 20px;
}


/deep/ .el-timeline .el-timeline-item__timestamp.is-top {
  position: absolute;
  left: -50px;
  top: -1px;
  color: #333333;
}
/deep/ .el-timeline {
  padding-left: 50px;
}

>>>.el-timeline-item__node{
  background-color: #001646;
}

>>>.el-timeline-item__tail{
  border-left: 2px dashed  #001646;
}

.time{
  border-bottom: 1px solid #959595;
  padding-bottom: 15px;
  margin-bottom: 25px;
  color: #898989;
}

.title-name{
  display: flex;
  justify-content: space-between;
}

.time-title{
  font-size: 16px;
}

.model{
  background-color: #001646;
  border-radius: 10px;
  padding: 4px 20px;
  color: #FFFFFF;
}

.time-content{
  font-size: 14px;
  font-family: unset;
  color: #898989;
  line-height: 2em;
  margin-top: 10px;
}

.vip{
  width: 120px;
  background-color: #001646;
  border-radius: 10px;
  padding: 4px 0;
  color: #FFFFFF;
  text-align: center;
  margin-top: 10px;
}


.list {
  margin: 10px 0;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.zx-list {
  width: 1200px;
  margin-top: 10px;
}

>>> .el-tabs__item {
  width: 160px;
  text-align: center;
  color: #313131;
  background-color: #FFFFFF;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}

>>> .is-active {
  color: #FFFFFF;
  height: 30px;
  background-image: linear-gradient(#0c255c, #040f27);
}

>>> .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #E4E7ED;
  margin-right: 10px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Market.vue